import { Mapper } from "../../../../base/utils/mapper";
import { DevelopmentConsultOccupationalTherapyResponseEntity } from "../entities/development-consult-occupational-therapy-response.entity";
import { DevelopmentConsultOccupationalTherapyResponseModel } from '../../../../domain/models/consult/development-consult-occupational-therapy-response.model';



export class DevelopmentConsultOccupationalTherapyImplementationRepositoryMapper extends Mapper<DevelopmentConsultOccupationalTherapyResponseEntity, DevelopmentConsultOccupationalTherapyResponseModel> {
    mapFrom(param: DevelopmentConsultOccupationalTherapyResponseEntity): DevelopmentConsultOccupationalTherapyResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DevelopmentConsultOccupationalTherapyResponseModel): DevelopmentConsultOccupationalTherapyResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    } 
}